export default __webpack_public_path__ + "static/media/learntodoapp-desktop.249e6184.png";